export default __webpack_public_path__ + "static/media/G0005.6d0b28dc.png";